import $ from 'jquery';
import _ from 'lodash';
import Backbone from 'backbone';
import JSON from 'json3';
import Promise from "bluebird";

export const ID = {
	approvalBookingTypes: {app: "BUCH", crit: "FREIGABE", subCrit: "BUART"},
	approvalCostCenterBookingTypes: {app: "BUCH", crit: "FREIGABE", subCrit: "BUART_K"},
	bookingEndNoCheck: {app: 'P40507', crit: 'SCHLUSS', subCrit: 'NOCHECK'},
	approvalNoCheck: {app: 'P40507', crit: 'FREIGABE', subCrit: 'NOCHECK'}, //add approval*BookingTypes
	bewEinhRequired: {app: "KONT", crit: "KOSTENST", subCrit: "ZWINGEND"},
	bewEinhMustMatch: {app: "KONT", crit: "KOSTENST", subCrit: "PRUEF"},
	bewEinhText: {app: "KONT", crit: "KOSTENST", subCrit: "TEXT"},
	empfEinhRequired: {app: "KONT", crit: "AUFT", subCrit: "ZWINGEND"},
	empfEinhMustMatch: {app: "KONT", crit: "AUFT", subCrit: "PRUEF"},
	empfEinhText: {app: "KONT", crit: "AUFT", subCrit: "TEXT"},
	kartNrLength: {app: "P001123", crit: "KARTELEN", subCrit: "LAENGE"},
	showOffenKz: {app: "P00205S", crit: "OFFENKZ", subCrit: "SHOW"},
	showOffenKzForStuart: {app: "P00205S", crit: "OFFENKZ", subCrit: "SA"},
	calendar_presencePlanningShowAbsent: {app: "P40506", crit: "ABWESEND", subCrit: "SHOW"},
	showRepresentative: {app: "P00205S", crit: "VERTRETER", subCrit: "SHOW"},
	showRepresentative1: {app: "P00205S", crit: "VERTRETER1", subCrit: "SHOW"},
	requiredTextBookingTypes1: {app: "BUCH", crit: "BEMERK_B", subCrit: "ZWINGEND"},
	requiredTextBookingTypes2: {app: "BUCH", crit: "BEMERK_B2", subCrit: "ZWINGEND"},
	requiredTextBookingTypes3: {app: "BUCH", crit: "BEMERK_B3", subCrit: "ZWINGEND"},
	requiredTextHourCategories: {app: "P00205S", crit: "BEMERK_S", subCrit: "ZWINGEND"},
	//aze
	showAzeApproveWeekButton: {app: "P1007", crit: "WOCHEFREIG", subCrit: "SHOW"},
	//tms
	pzeClass: {app: "BUCH", crit: "PZETAG", subCrit: "CLASS"}, //tms-paramdiv
	tmsDummyPSP: {app: "BUCH", crit: "PSP", subCrit: "DUMMY"}, //tms dummyPSP
};
Object.freeze(ID);

const ParamdivModel = Backbone.Model.extend({
	idAttribute: "compositeId",
	initialize: function (attributes) {
		let key = attributes;
		this.set({compositeId: key.app + "_" + key.crit + "_" + key.subCrit}, {silent: true});
	},
	url: function () {
		let app = this.get('app');
		let crit = this.get('crit');
		let subCrit = this.get('subCrit');
		if (!app || !crit || !subCrit) throw new Error('Paramdiv parameters not correctly specified');
		return "../json/paramdiv?app=" + app + "&crit=" + crit + "&subCrit=" + subCrit;
	},
	parse: function (response) {
		// object attribute merge to not loose defer, write not implemented.
		return _.assign({}, this.attributes, {value: response.value});
	},
});

const ParamdivCollection = Backbone.Collection.extend({
	model: ParamdivModel,
	url: "../json/paramdivs",
	/**
	 * Fetches all Paramdivs in array. Use while initializing app to
	 * @param paramdivIDs {ID | [ID]}
	 * @returns {$.Deferred} chain-deferred in same order, always use callback interface (done/fail/always)
	 */
	fetchMultipleDeferred(...paramdivIDs) {
		return $.when(...this.fetchMultiple(...paramdivIDs));
	},
	fetchMultiplePromise(...paramdivIDs) {
		return Promise.all(this.fetchMultiple(...paramdivIDs));
	},
	fetchMultiple: function (...paramdivIDs) {
		let that = this;
		let retDeferreds = [];
		// check which are not fetched/already in collection
		let notFetched = [];
		_.each(paramdivIDs, function (id) {
			if (!_.includes(ID, id)) {
				console.error("not a Paramdiv.ID, and therefore ignored: " + id);
				return;
			}
			let exists = that.findWhere(id);
			if (exists) {
				retDeferreds.push(exists.get("defer"));
			} else {
				let $_new = new $.Deferred();
				retDeferreds.push($_new);
				notFetched.push(
					new ParamdivModel(
						_.assign({}, id, {defer: $_new}),
					),
				);
			}
		});
		if (!_.isEmpty(notFetched)) {
			// new data to fetch, add new ones
			let fetchedModels = this.add(notFetched);

			//prepare data for not fetched
			//todo also fetch single fetches in Collection, (add single and wait for
			let data = _.map(notFetched, function (m) {
				return m.omit(["defer", "compoundId"]);
			});
			let $_fetchAll = this.fetch({
				merge: true, // models are already added, only value added
				remove: false, // keep already fetched from other calls
				type: "POST",
				contentType: "application/json",
				data: JSON.stringify(data),
			});
			$_fetchAll.done(function () {
				_.each(fetchedModels, function (m) {
					m.get("defer").resolve(m.get("value"));
				});
			});
			$_fetchAll.fail(function () {
				_.each(fetchedModels, function (m) {
					m.get("defer").reject();
					that.remove(m)
				});
			});
		}
		return retDeferreds
	},
	/**
	 * can be used with ID objects of this module or with plain strings.
	 * Usage of ID object is recommended and String usage will soon be deprecated / removed.
	 * The ID object helps usage search and centralizes parameter values.
	 *
	 * @param app {ID}
	 * @param [crit] {String} deprecated
	 * @param [subCrit] {String} deprecated
	 * @return {$.Deferred} resolving with an array of strings (value of paramdiv)
	 */
	getParamdiv: function (app, crit, subCrit) {
		let params;
		if (typeof app === "object") params = app;
		else {
			console.warn("deprecated call of getParamdiv(app,crit,subCrit) -> use getParamdiv(ID)");
			params = {app: app, crit: crit, subCrit: subCrit};
		}
		let model;
		if (model = this.findWhere(params)) {
			//data present
			let $_fetchCall = model.get('defer');
			if ($_fetchCall.state() == "resolved") return model.get('value');
			else return $_fetchCall;
		} else {
			//no data, no running requests
			let defer = $.Deferred(); // for directly resolving with the value (unwrapping the model)
			model = this.add(_.assign({}, params, {defer: defer}));
			model.fetch().done(function () {
				defer.resolve(model.get('value'));
			}).fail(function () {
				defer.reject();
			});
			return defer;
		}
	},
});
const paramdivCollection = new ParamdivCollection();

export default {
	/**
	 * deferred usage:
	 *
	 * $.when(Paramdiv.get(Paramdiv.id.propid)).always(function (propidValue) { use here });
	 *
	 * multiple paramdivs:
	 * $.when.apply(this,[Paramdiv.get(..),Paramdiv.get(..), ...]).done(function(result1,result2, ...){ use here results });
	 *
	 * or equivalent:
	 * $.when(Paramdiv.get(..),Paramdiv.get(..), ...).done(function(result1,result2, ...){ use here results });
	 *
	 * ********************
	 * possible "synchronous usage"
	 *
	 * let ajaxLoading = Paramdiv.get(Paramdiv.id.propid); // load Paramdiv data before starting app
	 * $.when(ajaxLoading).always(function(){ startAppHere() });
	 *
	 * in startAppHere() you can savely call Paramdiv.get(Paramdiv.id.propid) again without calling server again:
	 * const paramdiv = Paramdiv.get(Paramdiv.id.propid);
	 *
	 * for usage with multiple paramdivs, see above
	 *
	 */
	fetchMultipleDeferred: _.bind(paramdivCollection.fetchMultipleDeferred, paramdivCollection),
	fetchMultiplePromise: _.bind(paramdivCollection.fetchMultiplePromise, paramdivCollection),
	fetchMultiple: _.bind(paramdivCollection.fetchMultiple, paramdivCollection),
	/**
	 * @deprecated use fetch Multiple
	 */
	get: _.bind(paramdivCollection.getParamdiv, paramdivCollection),
	ID: ID,
};